import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=3f53fe40&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VLayout,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\eLpass\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f53fe40')) {
      api.createRecord('3f53fe40', component.options)
    } else {
      api.reload('3f53fe40', component.options)
    }
    module.hot.accept("./ProductDetail.vue?vue&type=template&id=3f53fe40&", function () {
      api.rerender('3f53fe40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Product/ProductDetail.vue"
export default component.exports